import styled from '@emotion/styled';
import {fontSize, sizes} from 'patient-ping-remedy/packages/theme';

// Puts the play control / audio player on its own line beneath the transcript
// text, with a small gap so it reads as a related but separate element.
const PlayerRow = styled('div')`
  display: block;
  margin-top: ${sizes.xSmall};
`;

// Class applied to the Remedy Button (which has no size prop, but forwards
// className). Shrinks padding and font-size so the button sits more in line
// with the surrounding body text instead of dominating it.
const compactPlayButtonClass = 'voicemail-compact-play';

const CompactButtonStyles = styled('div')`
  .${compactPlayButtonClass} {
    padding: ${sizes.xxSmall} ${sizes.small};
    font-size: ${fontSize.small};
    border-radius: 6px;
  }
`;

// Native <audio> control: constrain height and max width so the default
// player is more compact and closer to the text scale on the page.
const CompactAudio = styled('audio')`
  display: block;
  height: 2.4rem;
  max-width: 26rem;
  width: 100%;
`;

export {PlayerRow, CompactButtonStyles, compactPlayButtonClass, CompactAudio};
